module.exports = __webpack_public_path__ + "img/nkp_logo.336c16d8.png";